var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowback({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 32,
    height: 32,
    rx: 8,
    ry: 8,
    fill: "rgba(250, 249, 248, 0.2)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4 16L17.3 12.1001C17.4833 11.9167 17.575 11.6834 17.575 11.4001C17.575 11.1167 17.4833 10.8834 17.3 10.7001C17.1166 10.5167 16.8833 10.425 16.6 10.425C16.3166 10.425 16.0833 10.5167 15.9 10.7001L11.3 15.3C11.2 15.4 11.1291 15.5084 11.0875 15.625C11.0458 15.7417 11.025 15.8667 11.025 16C11.025 16.1334 11.0458 16.2584 11.0875 16.375C11.1291 16.4917 11.2 16.6 11.3 16.7L15.9 21.3C16.0833 21.4834 16.3166 21.575 16.6 21.575C16.8833 21.575 17.1166 21.4834 17.3 21.3C17.4833 21.1167 17.575 20.8834 17.575 20.6C17.575 20.3167 17.4833 20.0834 17.3 19.9L13.4 16Z",
    fill: "#faf9f8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowback);
export default __webpack_public_path__ + "static/media/arrowback.f9928ab1397949897ce51a6442f59deb.svg";
export { ForwardRef as ReactComponent };